import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as TableQL from "queries/table";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";

import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params } }) => {
  const {
    parent: { base },
    values,
  } = useSectionContext();

  const rowCount = values?.rowCount || 0;

  return (
    <CancellableContent>
      <Row>
        <Col>
          Removing the table <b>{params.tableId}</b>
          {rowCount > 0 ? (
            <>
              {" "}
              and the <b>{rowCount.toLocaleString()}</b> row
              {rowCount === 1 ? "" : "s"} it holds
            </>
          ) : null}
          ? This action will be permanent and can't be undone.
          {/* Said out loud because the rows are not in the row: they are a
              separate object in S3, and a person who has only ever seen the
              listing has no reason to expect them to go with it. They do —
              model/table.remove takes them first, because the row is the only
              thing that names them. */}
        </Col>
      </Row>
      <Mutation
        mutation={TableQL.remove}
        update={TableQL.update(params)}
        onMutate={({ handler }) => {
          handler({
            variables: params,
          });
        }}
        onCompleted={() => {
          history.replace(base);
        }}
        onError={(error) => {
          Notify.error(error.toString());
        }}
      >
        {MutationHandler}
      </Mutation>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Button
            onClick={() => {
              mutate();
            }}
          >
            Remove
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
